"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var _1 = require("./");

var styled_1 = __importDefault(require("@emotion/styled"));

var uuid_1 = require("uuid");

var GroupRadioButton = function GroupRadioButton(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? (0, uuid_1.v4)() : _ref$id,
      value = _ref.value,
      options = _ref.options,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? (0, uuid_1.v4)() : _ref$name,
      onChange = _ref.onChange,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      language = _ref.language,
      sizeMobile = _ref.sizeMobile;
  var Container = styled_1.default.fieldset(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tborder: 0;\n\t\tdisplay: inline-block;\n\t"])));

  var onChangeHandler = function onChangeHandler(value) {
    onChange(value);
  };

  return (0, jsx_runtime_1.jsx)(Container, {
    children: options.map(function (option, index) {
      return (0, jsx_runtime_1.jsx)(_1.RadioButton, {
        className: "radio-button",
        name: name,
        checked: value === option.value,
        label: option.display,
        onChange: onChangeHandler,
        value: option.value,
        disabled: option.disabled,
        size: size,
        type: type,
        id: id + index,
        dataTestId: id,
        language: language,
        description: option === null || option === void 0 ? void 0 : option.description,
        sizeMobile: sizeMobile
      }, option.value);
    })
  });
};

exports.default = GroupRadioButton;